import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, from } from 'rxjs';
import { EnvironmentService } from '../environment/environment.service';
import { environment } from 'src/environments/environment';
import { filter, switchMap, take } from 'rxjs/operators';
import { Storage } from '@ionic/storage-angular';
import { StorageService } from '../storage/storage.service';


@Injectable({
  providedIn: 'root'
})
export class ApiService extends StorageService {

  private headers: any;

  public base_url = new BehaviorSubject(null);

  constructor(
    private http: HttpClient,
    private environment: EnvironmentService,
    protected override storage: Storage
  ){
    super(storage);
    this.localStorageKey = 'api_url';
    let headers = {};
    let url = localStorage.getItem('url');
    this.base_url.next(url);
    this.headers = new HttpHeaders(headers);
  }

  // get<T>(endpoint: string, params = {}, external = false) {

  //   if (!external) {
  //     endpoint = this.getFullUrl(endpoint);
  //   }

  //   return this.http.get<T>(endpoint, {
  //     headers: this.headers,
  //     params
  //   });
  // }

  // get<T>(endpoint: string, params = {}, external = false) {
  //   if (external) {
  //     return this.http.get<T>(endpoint, { headers: this.headers, params });
  //   }
  
  //   return this.base_url.pipe(
  //     filter(url => !!url),
  //     take(1),
  //     switchMap(url => this.http.get<T>(url + endpoint, { headers: this.headers, params }))
  //   );
  // }

  // get<T>(endpoint: string, params = {}, external = false) {
  //   if (external) {
  //     return this.http.get<T>(endpoint, { headers: this.headers, params });
  //   }
  
  //   return this.base_url.pipe(
  //     filter(url => !!url),
  //     take(1),
  //     switchMap(url => {
  //       if (endpoint.charAt(0) !== '/') {
  //         endpoint = '/' + endpoint;
  //       }
  //       return this.http.get<T>(url + endpoint, {
  //         headers: this.headers,
  //         params
  //       });
  //     })
  //   );
  // }

  get<T>(endpoint: string, params = {}, external = false) {
    if (external) {
      return this.http.get<T>(endpoint, {
        headers: this.headers,
        params
      });
    }
  
    if (this.base_url.getValue()) {
      return this.http.get<T>(this.getFullUrl(endpoint), {
        headers: this.headers,
        params
      });
    }
  
    return from(this.getFullUrlAsync(endpoint)).pipe(
      switchMap(fullUrl => this.http.get<T>(fullUrl, {
        headers: this.headers,
        params
      }))
    );
  }
  
  // post(endpoint, params = {}) {
  //   return this.http.post(this.getFullUrl(endpoint), params, {
  //     headers: this.headers
  //   });
  // }

  post(endpoint: string, params = {}) {
    if (this.base_url.getValue()) {
      // Normal case — base_url is ready
      return this.http.post(this.getFullUrl(endpoint), params, {
        headers: this.headers
      });
    }
  
    // Fallback — resolve base_url on the fly
    return from(this.getFullUrlAsync(endpoint)).pipe(
      switchMap(fullUrl =>
        this.http.post(fullUrl, params, {
          headers: this.headers
        })
      )
    );
  }

  // delete(endpoint, params = {}) {
  //   return this.http.delete(this.getFullUrl(endpoint), {
  //     params,
  //     headers: this.headers,
  //   });
  // }

  delete(endpoint: string, params = {}) {
    if (this.base_url.getValue()) {
      return this.http.delete(this.getFullUrl(endpoint), {
        params,
        headers: this.headers,
      });
    }
  
    return from(this.getFullUrlAsync(endpoint)).pipe(
      switchMap(fullUrl =>
        this.http.delete(fullUrl, {
          params,
          headers: this.headers
        })
      )
    );
  }

  private getFullUrl(endpoint: string): string {
    const url = this.base_url.getValue();
    if (!url) {
      throw new Error('Base URL is not set — maybe AppInitializer didn’t run?');
    }
    if (endpoint.charAt(0) !== '/') {
      endpoint = '/' + endpoint;
    }
    return url + endpoint;
  }

  getApiUrl(): Promise<string> {
    return new Promise((resolve, reject) => {
      this.get(`${environment.apiCheckUrl}?version=${encodeURIComponent(environment.api.version)}`, null, true)
        .subscribe({
          next: (url: string) => {
            localStorage.setItem('url', url);
            localStorage.setItem('clear_url_at', `${Date.now() + (1 * 24 * 60 * 60 * 1000)}`);
            this.setBaseUrl(url);
            this.storage.set(this.localStorageKey, url);
            resolve(url);
          },
          error: (err) => {
            console.error('Failed to get API URL', err);
            reject(err);
          },
        });
    });
  }

  async getFullUrlAsync(endpoint: string): Promise<string> {
    let url = this.base_url.getValue();
  
    if (!url) {
      // Try to refresh from remote
      url = await this.getApiUrl();
    }
  
    if (!url) {
      throw new Error('Base URL could not be resolved.');
    }
  
    if (endpoint.charAt(0) !== '/') {
      endpoint = '/' + endpoint;
    }
  
    return url + endpoint;
  }
  
  

  public setBaseUrl(url) {
    
    this.base_url.next(url);
  }

}